import View from "../views/container";
import { BaseUrl } from "../lib/Constants";
import Packages from "../views/Packages";
import SmsLang from "../views/Sms-Lang";
import PaymentReceipt from "../views/PaymentReceipt";
import Home from "../views/Home";

//Main routes
let indexRoutes = [
	{ path: `${BaseUrl}`, component: View },
	{ path: "/packages", component: Packages },
	{ path: "/sms-language", component: SmsLang },
	{ path: "/payment", component: PaymentReceipt },
];

export default indexRoutes;
